export function HeroSection() {
  return (
    <div className="flex items-center justify-center text-center px-4">
      <div className="max-w-[90%]">
        <h1
          className="text-3xl sm:text-[2.2em] md:text-[2.7em] font-semibold mb-2 leading-tight"
          style={{
            background: "var(--gradientTextGreen)",
            WebkitTextFillColor: "transparent",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            display: "inline-block",
          }}
        >
          Free Instagram Fake Follower Checker
        </h1>
        <h2 className="text-base sm:text-lg text-gray-400 mb-4 leading-relaxed">
          Audit any Instagram account&apos;s followers for free using our fake
          follower checker
        </h2>
      </div>
    </div>
  );
}

export default HeroSection;
